// extracted by mini-css-extract-plugin
export default {"showMoreAdditionsFieldsBtn":"AdditionalFields_showMoreAdditionsFieldsBtn__agbCz","flippedIcon":"AdditionalFields_flippedIcon__Y57oH"};